import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSS = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M48.049 15.308C44.263 6.315 35.369 0 24.999 0A24.918 24.918 0 0 0 7.322 7.323l6.261 7.985H48.05Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "m13.654 34.602-6.332 8.075A24.918 24.918 0 0 0 25 50c10.405 0 19.324-6.357 23.088-15.398H13.654Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M5.434 18.387v13.134h43.703C49.699 29.442 50 27.256 50 25c0-2.29-.309-4.506-.885-6.613H5.434Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M7.323 7.322c-9.763 9.763-9.763 25.592 0 35.355L25.001 25 7.323 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m8.143 18.784 3.051 4.258 4.993-1.586-3.107 4.218 3.052 4.258-4.972-1.651-3.106 4.218.034-5.239-4.972-1.651 4.993-1.587.034-5.238Z"
}));
FlagSS.displayName = 'FlagSS';
export default withFlagWrapper(FlagSS);
//# sourceMappingURL=index.js.map